export const USER_ROLE = {
    ADMIN: 'admin',
    SUPER_ADMIN: 'super_admin'
}
export const LOCALE = {
    EN: { code: 'en', name: "English" },
    NL_BE: { code: 'nl-BE', name: "nederlands" },
    DE_DE: { code: 'de-DE', name: "Deutsch" },
    FR_BE: { code: 'fr-BE', name: "français" },
}